import React, { Component } from "react";
import { Link } from "react-router-dom";
import ResourceMenu from "./ResourceMenu";
// import axios from 'axios';
// import { decode } from 'html-entities';

export class MainNav extends Component {
  state = {
    mainnav: [],
    resourcesOpen: false,
  };

  toggleResources = () => {
    this.setState(({ resourcesOpen }) => ({ resourcesOpen: !resourcesOpen }));
  };

  componentDidMount() {
    const navCont = document.querySelector("#main-nav");
    const links = document.querySelectorAll("#main-nav a");
    const navBttn = document.querySelector(".hamburger");
    // console.dir(links);

    links.forEach((e) => {
      e.addEventListener("click", function () {
        navCont.classList.toggle("open");
        navBttn.classList.toggle("open");
      });
    });
  }

  render() {
    return (
      <>
        <nav id="main-nav" className="slidingNav">
          <ul>
            <li>
              <Link to="/">
                <i className="fa fa-bars"></i> Calendar &amp; Upcoming Events
              </Link>
            </li>
            {/* <li><a href="https://usa.libcal.com/calendar/ilearn" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-calendar"></i> Calendar &amp; Upcoming Events
            </a></li> */}

            <li>
              <Link to="/allvideos/">
                <i className="fa fa-play"></i> Recordings of Past Sessions
              </Link>
            </li>

            {/* <li><a href="https://library.usa.edu/" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-book"></i> Library
            </a></li> */}

            {/* <li><a href="https://my.usa.edu/ICS/Student_Services/Writing_Center/" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-pencil-alt"></i> Writing Center
            </a></li> */}

            {/* <li><a href="https://my.usa.edu/ICS/Student_Services/Career_Services/" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-user-md"></i> Career Services
            </a></li> */}

            {/* <li><a href="https://my.usa.edu/ICS/Student_Services/Academic_Advising/" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-comments"></i> Advising
            </a></li> */}

            {/* <li><a href="https://my.usa.edu/ICS/Student_Services/Tutoring/" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-book-reader"></i> Tutoring
            </a></li> */}

            {/* <li><a href="https://my.usa.edu/ICS/Academics_2017-08-22T17-14-45-332/" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-graduation-cap"></i> Academics by Program
            </a></li> */}

            {/* <li><a href="https://catalog.usa.edu/" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-university"></i> University Catalog/Handbook
            </a></li> */}

            <li>
              <a
                href="https://help.usa.edu/hc/en-us/articles/26000670868887-Blackboard-Quick-Start-Guide-For-Students"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-desktop"></i> Blackboard Ultra Student
                Support
              </a>
            </li>

            <li>
              <a
                href="https://usahs.sharepoint.com/sites/USAHSProBonoClinicalExperiences"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-stethoscope"></i> Pro Bono Clinical
                Experiences
              </a>
            </li>

            <li>
              <a
                href="https://www.youtube.com/channel/UCbqNn3yZdyjOfVCrvuABbeg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-laptop-medical"></i> Virtual Wellness Hub
              </a>
            </li>

            <li>
              <Link to="/about">
                <i className="fa fa-info-circle"></i> About iLearn
              </Link>
            </li>

            <li className="mainNavResources">
              <button
                type="button"
                className="mainNavResources__toggle"
                aria-expanded={this.state.resourcesOpen}
                onClick={this.toggleResources}
              >
                <span>
                  <i className="fa fa-link"></i> Resources
                </span>
                <i
                  className={`fas fa-chevron-${this.state.resourcesOpen ? "up" : "down"}`}
                  aria-hidden="true"
                ></i>
              </button>
              {this.state.resourcesOpen && <ResourceMenu />}
            </li>
          </ul>

          <div className="nav-copyright">
            <img
              src={
                process.env.PUBLIC_URL +
                "/global/images/logos/usa-logo-whitesm.png"
              }
              alt="University of St. Augustine for Health Sciences"
            />
          </div>
        </nav>
      </>
    );
  }
}

export default MainNav;
